export const breadcrumb = {
  root: {
    padding: '0.5em 1em',
  },
};
